import React from 'react';
import '../common.css';
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";

// get table configurations
const table = tableConfigs.consumerKey;

class ConsumerKey extends React.Component {
    constructor(props) {
        super(props);
        EventEmitter.emit('setPageHeaderData', {
            page: 'consumer-key',
            pageName: "Consumer Key",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/consumer-key",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    render() {
        return(
            <div className={'page-mainLayout'}>
                <Table tableConfig={table} routerProps={this.props}/>
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Configure"
                         onClick={() => this.props.history.push('/home/utf-enabled-consumer-key/config')}>
                        <i className="fa fa-cog fa-lg icon-primary" />
                    </div>
                </div>
            </div>
        )
    }
}

export default ConsumerKey;